import { Component } from '@angular/core';

@Component({
  selector: 'app-one-trust',
  imports: [],
  template: '',
})
export class OneTrustComponent {
  constructor() {
    const initScript = document.createElement('script');
    initScript.type = 'text/javascript';
    initScript.innerHTML =
      'function OptanonWrapper() {' +
      'if(window.oneTrustLoaded) return;' +
      "const oneTrustLoadedEvent = new CustomEvent('oneTrustLoaded');" +
      'window.dispatchEvent(oneTrustLoadedEvent);' +
      'window.oneTrustLoaded = true;' +
      '}';
    document.head.appendChild(initScript);
  }
}
